import { FiCheckCircle } from 'react-icons/fi';

const CalendarEventContent = ({ event, timeText }) => {
    const showCheck = event.extendedProps?.status === 1;
    const label = [timeText, event.title].filter(Boolean).join(' ');

    return (
        <div className="calendar-event-content flex w-full min-w-0 items-center justify-between gap-1.5 px-0.5">
            <span className="min-w-0 flex-1 truncate">{label}</span>
            {showCheck && (
                <FiCheckCircle
                    className="calendar-event-check shrink-0"
                    size={14}
                    aria-hidden="true"
                />
            )}
        </div>
    );
};

export { CalendarEventContent };
